import React, { Component } from 'react';
import { Row, Col, Container, Button } from "reactstrap";
import { Link } from "react-router-dom";
import ModalAviso from "../../../comum/components/ModalAviso";
import moment from "moment"

export default class AgendItem extends Component {
    constructor(props) {
        super(props);
        this.agend = this.props.agend;
        this.filtros = this.props.filtros;
        this.controller = this.props.controller;
        this.mensagem = false;
    }

    situacaoCss = (statusTriagem) => statusTriagem.toLowerCase().replace(/\s|\./g, '-').replace('--', '-')

    modalExibirMensagem = () => {
            return <ModalAviso onClickFechar={() => this.fecharModal()}> {this.mensagem} </ModalAviso>
    }

    fecharModal = () => {
        this.mensagem = false;
    }

    validarTriagem = (agendId) => {
        document.getElementById(agendId).disabled = true;
        this.controller.validarTriagem(agendId).then((response) => {
            if(response.data) {
                console.log("Triagem validada com sucesso");
            }else {
                console.log("Ocorreu um erro ao validar a Triagem deste agendamento");
                document.getElementById(agendId).disabled = false;
            }
        }).catch(error => {
            console.log(error);
        })        
    }

    render() {
        return (
            <div className="container-item p-3 d-flex">
                {this.mensagem && this.modalExibirMensagem()}
                <Container>
                    <Row className="mb-1">
                        <Col><span className="Cntr">{this.agend.Placa}</span></Col>
                    </Row>
                    <Row className="mb-2">
                        <Col><span >Carreta(s): {this.agend.PlacaCarret1} {this.agend.PlacaCarret2 ? ' - ' + this.agend.PlacaCarret2 : "" }</span></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col className="px-3">
                            {
                                <span className={"font-weight-bold situacao " + this.situacaoCss(this.agend.StatusTriagem)} dangerouslySetInnerHTML={{ __html: (this.agend.StatusTriagem)}} ></span>
                            }
                        </Col>
                    </Row>
                    {this.situacaoCss(this.agend.StatusTriagem) === "no-horario" &&
                    <Row className="mb-3">
                        <Col className="px-3">
                            <Button id={this.agend.AgendId} className="btn-com-bordas-primary btn btn-filtrar btn-secondary" onClick={() => this.validarTriagem(this.agend.AgendId)} outline>
                                Validar Triagem
                            </Button>
                        </Col>
                    </Row>
                    }
                    <Row className="mb-3">
                        <Col className="box mr-1 py-2">
                            <Row>
                                <Col><span className={'font-weight-bold'}>{this.agend.NomeMotorista}</span></Col>
                            </Row>
                            <Row>
                                <Col><span>CNH: {this.agend.Cnh}</span></Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col className="box mr-1 py-2">
                            <Row>
                                <Col> <span className={'font-weight-bold'}>DATA:</span> {`${moment(this.agend.Data).format("DD/MM/YYYY")}`} -  <span className={'font-weight-bold'}>HORA:</span> {this.agend.Hora}</Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="mb-0">
                        <Col><span >{this.agend.DscTipo}</span></Col>
                    </Row>
                </Container>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/modules/agendamento/depot-triagem/components/AgendItem.js